import { Chip } from "@gigpro/ui/Chip";
import { Skeleton } from "@gigpro/ui/Skeleton";
import { useProProfile } from "api/queries/pros";
import type React from "react";

type PROfileCertificationsContainerProps = { id: number };

export const PROfileCertificationsContainer: React.FC<PROfileCertificationsContainerProps> = ({ id }) => {
  const { data } = useProProfile(id);

  const content = data?.certifications.length ? (
    <div className="flex flex-wrap gap-2">
      {data.certifications.map(({ id, name }) => (
        <Chip key={id} data-testid={`chip-certification-${name}`}>
          {name}
        </Chip>
      ))}
    </div>
  ) : (
    <p className="text-medium-gray">No certifications.</p>
  );

  return (
    <>
      <h2 className="profile-title mb-3 text-large font-semibold @sm/profile:text-extraLarge">Certifications</h2>
      {data ? content : <Skeleton className="w-40 text-normal @sm/profile:text-large" />}
    </>
  );
};
